import React, { useState, useRef } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Link } from 'react-router-dom';

import {Button, Card, Form, Row, Col} from "react-bootstrap"
import { GiPadlock, GiPadlockOpen } from "react-icons/gi";
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import { MessageBar, MessageBarType } from '@fluentui/react';

import { createClient } from "../../actions/client-action";

import nnImg from '../../images/nn.png'
import { getValidPath, isValidFormControlUrl } from "../../common/Helpers";
import AuthVerify from "../../components/AuthVerify";

//#region Validadores de campos
const isInValidFormControl = (value) => {
  return value === "";
}

//#endregion

const CreateClient = () => {

  //#region Referencias, Constantes
  const { t } = useTranslation();

  const { user: currentAuth } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const form = useRef();
  const checkBtn = useRef();
  
  const [showpasswords, setShowpasswords] = useState(false);
  const [successful, setSuccessful] = useState(null);
  const { message } = useSelector(state => state.message);

  let client = {
    clientId: null,
    name: "",
    type: "",
    domain: "",
    locale: "",
    sqlKey: "",
    path: "https://unknow",
    blobStorageKey: "",
    blobStoragePath: "",
    apiManagementKey: ""
  };

  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [domain, setDomain] = useState("");
  const [locale, setLocale] = useState("");
  const [sqlKey, setSqlKey] = useState(null);
  const [path, setPath] = useState("");
  const [blobStorageKey, setBlobStorageKey] = useState(null);
  const [blobStoragePath, setBlobStoragePath] = useState(null);
  
  const [apiManagementKey, setApiManagementKey] = useState(null);

  const [showPasswordMessageBar, setShowPasswordMessageBar] = useState(true);
  
  const [isInvalidName, setIsInvalidName] = useState(false);
  const [isInvalidType, setIsInvalidType] = useState(false);
  const [isInvalidDomain, setIsInvalidDomain] = useState(false);
  const [isInvalidLocale, setIsInvalidLocale] = useState(false);
  const [isInvalidLegacypath, setIsInvalidLegacypath] = useState(false);
  const [isInvalidEmptyLegacypath, setIsInvalidEmptyLegacypath] = useState(false);
  
  //#endregion

  //#region Eventos Change (Usados para asignar valores a las propiedades constantes)
  const onChangeName = (e) => {
    let name = e.target.value;
    setIsInvalidName(name === "");
    setName(name);
  };

  const onChangeType = (e) => {
    let type = e.target.value;
    setIsInvalidType(type === "");
    setType(type);
  };

  const onChangeDomain = (e) => {
    let domain = e.target.value;
    setIsInvalidDomain(domain === "");
    setDomain(domain);
  };

  const onChangeLocale = (e) => {
    let locale = e.target.value;
    setIsInvalidLocale(locale === "");
    setLocale(locale);
  };

  const onChangeSqlConnectionString = (e) => {
    let sqlKey = e.target.value;
    setSqlKey(sqlKey);
  };

  const onChangeBlobStorageKey = (e) => {
    let blobStorageKey = e.target.value;
    setBlobStorageKey(blobStorageKey);
  };

  const onChangeBlobStoragePath = (e) => {
    let blobStoragePath = e.target.value;
    setBlobStoragePath(blobStoragePath);
  };

  const onChangeLegacypath = (e) => {
    let path = e.target.value;
    setPath(path);
  };

  const onChangeApiManagementKey = (e) => {
    let apiManagementKey = e.target.value;
    setApiManagementKey(apiManagementKey);
  };

  const onTogglePassword = () => {
    setShowpasswords(!showpasswords);
  };
  //#endregion

  //#region Eventos botones
  const handleClosePasswordMessageBar = () => {
    setShowPasswordMessageBar(false);
  }

  const handleCloseSuccessMessageBar = () => {
    setSuccessful(null);
    setShowPasswordMessageBar(true);
  }
  const handleCreate = (e) => {
    e.preventDefault();

    setSuccessful(null);
    let validPath = getValidPath(path)
    let _isInvalidName = isInValidFormControl(name);
    let _isInvalidType = isInValidFormControl(type);
    let _isInvalidDomain = isInValidFormControl(domain);
    let _isInvalidLocale = isInValidFormControl(locale);
    let _isInvalidEmptyLegacypath  = isInValidFormControl(path);
    let _isInvalidLegacypath = _isInvalidEmptyLegacypath ? false : !isValidFormControlUrl(validPath);
    
    if (!_isInvalidName && !_isInvalidType && !_isInvalidDomain && !_isInvalidLocale && !_isInvalidLegacypath && !_isInvalidEmptyLegacypath) {

      client = {
        clientId: null,
        name: name,
        type: type,
        domain: domain,
        locale: locale,
        sqlKey: sqlKey,
        path: validPath,
        blobStorageKey: blobStorageKey,
        blobStoragePath: blobStoragePath,
        apiManagementKey: apiManagementKey
      };

      dispatch(createClient(client)).then(() => {
        setShowPasswordMessageBar(false);
        setSuccessful(true);
      }).catch(() => {
        setShowPasswordMessageBar(false);
        setSuccessful(false);
      });
    }
    else {
      setIsInvalidName(_isInvalidName);
      setIsInvalidType(_isInvalidType);
      setIsInvalidDomain(_isInvalidDomain);
      setIsInvalidLocale(_isInvalidLocale);
      setIsInvalidLegacypath(_isInvalidLegacypath);
      setIsInvalidEmptyLegacypath(_isInvalidEmptyLegacypath)
      setShowPasswordMessageBar(true);
    }
  };
  //#endregion

  //#region Render
  return (
      <>
        <AuthVerify currentToken={currentAuth} />
        { currentAuth &&
          <Form ref={form}>
            <Row>
              <Col sm={12} md={12} lg={12} xl={12}>
                {successful && (
                  <MessageBar
                    dismissButtonAriaLabel="Close"
                    styles={{root:{marginTop: "-96px !important"}}}
                    messageBarType={ successful === true ? MessageBarType.success : MessageBarType.error }
                    onDismiss={()=> handleCloseSuccessMessageBar()}>
                    {t(message)}
                  </MessageBar>
                )}
                {showPasswordMessageBar &&
                  <MessageBar
                    dismissButtonAriaLabel="Close"
                    styles={{
                      root:{width: "100%", marginTop: "-96px !important", overflowY: "auto", height: "130px"},
                      text:{width: "100%", display: "block"},
                    }}
                    messageBarType={MessageBarType.warning}
                    onDismiss={()=> handleClosePasswordMessageBar()}>
                      <Row>
                        <Col xl={12}>
                          <b>{t('data-lang-msg-warning')}:</b><br/>
                          {t('data-lang-msg-client-policy')}
                        </Col>
                      </Row>
                      <br/>
                      <Row>
                        <Col style={{paddingBottom: "10px"}} md={6} lg={12} xl={6}>
                              <b>{t('data-lang-lbl-blobstoragekey')}</b><br/>
                              {t('data-lang-msg-storageaccount-key-policy')}
                        </Col>
                        <Col style={{paddingBottom: "10px"}} md={6} lg={4} xl={2}>
                              <b>{t('data-lang-lbl-blobstoragepath')}</b><br/>
                              {t('data-lang-msg-storageaccount-path-policy')}
                        </Col>
                        <Col style={{paddingBottom: "10px"}} md={6} lg={4} xl={2}>
                              <b>{t('data-lang-lbl-connectionstring')}</b><br/>
                              {t('data-lang-msg-sql-connectionstring-policy')}
                        </Col>
                        <Col style={{paddingBottom: "10px"}} md={6} lg={4} xl={2}>
                              <b>{t('data-lang-lbl-apimanagementkey')}</b><br/>
                              {t('data-lang-msg-apimanagement-key-policy')}
                        </Col>
                      </Row>
                      <br/>
                  </MessageBar>
                }
              </Col>
              <Col sm={12} md={12} lg={6} xl={6}>
                <Card className="rounded-3">
                  <Card.Header>
                    <Card.Title>
                      <h4 style={{float:"left"}}><b>{t('data-lang-pagename-createclient')}</b></h4>
                    </Card.Title>
                  </Card.Header>
                  <div className="mx-auto d-block d-sm-block d-md-none d-lg-none">  
                      <img alt="nn1" className="rounded-circle" width={125} src={nnImg}></img>
                  </div>
                  <div className="card-horizontal">
                    <div className="pt-4 d-none d-sm-none d-md-block d-lg-block">  
                      <img alt="nn2" className="rounded-circle" width={125} src={nnImg}></img>
                    </div>
                    <Card.Body className="col-xs-12">
                      <Row>
                          <Col xs={12} sm={12} md={6} lg={12} xl={6}>
                            <Form.Label>{t('data-lang-lbl-name')}</Form.Label>
                            <Form.Control
                              type="text"
                              className="form-control"
                              name="name"
                              value={name ?? ''}
                              onChange={onChangeName}
                              isInvalid={isInvalidName !== null ? isInvalidName : false}
                              placeholder=""
                              autoComplete="off"
                            />
                            {
                              isInvalidName === true &&
                              <div className="invalid-feedback">
                                {t('data-lang-msg-required-field')}
                              </div>
                            }
                          </Col>
                          <Col xs={12} sm={12} md={6} lg={12} xl={6}>
                            <Form.Label>{t('data-lang-lbl-locale')}</Form.Label>
                            <Form.Select
                              className="form-control"
                              onChange={onChangeLocale}
                              value={locale ?? ''}
                              isInvalid={isInvalidLocale !== null ? isInvalidLocale : false}
                            >
                              <option data-component-id="lblOptionSelect">{t('data-lang-lbl-select')}</option>
                              <option data-component-id="lblOptionSpanish">{t('data-lang-lbl-spanish')}</option>
                              <option data-component-id="lblOptionEnglish">{t('data-lang-lbl-english')}</option>
                            </Form.Select>
                            {
                              isInvalidLocale === true &&
                              <div className="invalid-feedback">
                                {t('data-lang-msg-required-field')}
                              </div>
                            }
                          </Col>
                      </Row>
                      <Row>
                          <Col xs={12} sm={12} md={6} lg={12} xl={6}>
                            <Form.Label>{t('data-lang-lbl-domain')}</Form.Label>
                            <Form.Control 
                              type="text"
                              className="form-control"
                              name="domain"
                              value={domain ?? ''}
                              onChange={onChangeDomain}
                              isInvalid={isInvalidDomain !== null ? isInvalidDomain : false}
                              placeholder=""
                              autoComplete="off"
                            />
                            {
                              isInvalidDomain === true &&
                              <div className="invalid-feedback">
                                {t('data-lang-msg-required-field')}
                              </div>
                            }
                          </Col>
                          <Col xs={12} sm={12} md={6} lg={12} xl={6}>
                            <Form.Label>{t('data-lang-lbl-type')}</Form.Label>
                              <Form.Select
                                className="form-control"
                                onChange={onChangeType}
                                value={type ?? ''}
                                isInvalid={isInvalidType !== null ? isInvalidType : false}
                              >
                                <option data-component-id="lblOptionSelect">{t('data-lang-lbl-select')}</option>
                                <option data-component-id="lblOptionLocal">Local</option>
                                <option data-component-id="lblOptionSAS">SAS</option>
                              </Form.Select>
                              {
                                isInvalidType === true &&
                                <div className="invalid-feedback">
                                  {t('data-lang-msg-required-field')}
                                </div>
                              }
                          </Col>
                          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Form.Label>{t('data-lang-lbl-legacyurl')}</Form.Label>
                            <div className="input-group">
                              <span className="input-group-text">https://</span>
                              <Form.Control
                                type="text"
                                className="form-control"
                                name="path"
                                value={path || ''}
                                onChange={onChangeLegacypath}
                                isInvalid={isInvalidLegacypath !== null ? isInvalidLegacypath || isInvalidEmptyLegacypath : false}
                              />
                            </div>
                            {
                              isInvalidEmptyLegacypath === true &&
                              <div className="d-block invalid-feedback">
                                {t('data-lang-msg-required-field')}
                              </div>
                            }
                            {
                              isInvalidLegacypath === true &&
                              <div className="d-block invalid-feedback">
                                {t('data-lang-msg-url-field')}
                              </div>
                            }
                          </Col>
                      </Row>
                    </Card.Body>
                  </div>
                </Card>
              </Col>
              <Col sm={12} md={12} lg={6} xl={6}>
                <Card className="rounded-3">
                  <Card.Header>
                    <Card.Title>
                      <h4 style={{float:"left"}}><b>{t('data-lang-boxname-configuration')}</b></h4>
                      <div onKeyDown={onTogglePassword} onClick={onTogglePassword} className="float-end" role="button" tabIndex={-1}>
                        {!showpasswords &&
                          <div className="btn">
                            <GiPadlock/>{t('data-lang-lbl-showkeys')}
                          </div>
                        }
                        {showpasswords &&
                          <div className="btn">
                            <GiPadlockOpen/>
                            &nbsp;&nbsp;{t('data-lang-lbl-hidekeys')}
                          </div>
                        }
                      </div>
                    </Card.Title>
                  </Card.Header>
                  <div className="card-horizontal">
                    <Card.Body className="col-xs-12">
                      <Row>
                        <Col xs={12} sm={12} md={6} lg={12} xl={6}>
                          <Form.Label>{t('data-lang-lbl-connectionstring')}</Form.Label>
                          <Form.Control 
                            type={showpasswords ? "text" : "password"}
                            className="form-control"
                            name="inputSqlConnString"
                            value={sqlKey ?? ''}
                            onChange={onChangeSqlConnectionString}
                            placeholder={t('data-lang-placeholder-connectionstring')}
                            autoComplete="off"
                          />
                        </Col>
                        <Col xs={12} sm={12} md={6} lg={12} xl={6}>
                          <Form.Label>{t('data-lang-lbl-apimanagementkey')}</Form.Label>
                          <Form.Control 
                            type={showpasswords ? "text" : "password"}
                            className="form-control"
                            name="inputApiMngrKey"
                            value={apiManagementKey ?? ''}
                            onChange={onChangeApiManagementKey}
                            placeholder={t('data-lang-placeholder-apimanagementkey')}
                            autoComplete="off"
                          />
                        </Col>
                      </Row>
                      <Row>
                          <Col xs={12} sm={12} md={6} lg={12} xl={6}>
                            <Form.Label>{t('data-lang-lbl-blobstoragepath')}</Form.Label>
                            <Form.Control 
                              type={showpasswords ? "text" : "password"}
                              className="form-control"
                              name="inputBlobStorageKey"
                              value={blobStorageKey ?? ''}
                              onChange={onChangeBlobStorageKey}
                              placeholder={t('data-lang-placeholder-blobstoragepath')}
                              autoComplete="off"
                            />
                          </Col>
                          <Col xs={12} sm={12} md={6} lg={12} xl={6}>
                            <Form.Label>{t('data-lang-lbl-blobstoragekey')}</Form.Label>
                            <Form.Control 
                              type={showpasswords ? "text" : "password"}
                              className="form-control"
                              name="inputBlobStoragePath"
                              value={blobStoragePath ?? ''}
                              onChange={onChangeBlobStoragePath}
                              placeholder={t('data-lang-placeholder-blobstoragekey')}
                              autoComplete="off"
                            />
                          </Col>
                      </Row>
                    </Card.Body>
                  </div>
                </Card>
              </Col>
            </Row>
            <Row className="d-md-flex justify-content-md-end">
              <Col xs={12} sm={6} md={4} lg={3} xl={3} xxl={2}>
                {
                  client.clientId === null &&
                  <Button onClick={handleCreate} className="btn btn-primary col-12 mt-2">{t('data-lang-btn-create')}</Button>
                }
              </Col>
              <Col xs={12} sm={6} md={4} lg={3} xl={3} xxl={2}>
                <Link to="/profile">
                  <Button className="btn btn-primary col-12 mt-2">{t('data-lang-btn-gohome')}</Button>
                </Link>
              </Col>
            </Row>
            <Form.Check style={{ display: "none" }} ref={checkBtn} />
          </Form>
        }
        { !currentAuth &&
          <Shimmer
              customElementsGroup={
                <div>
                  <div style={{ display: 'flex' }}>
                      <ShimmerElementsGroup
                          shimmerElements={[
                              { type: ShimmerElementType.circle, height: 125 },
                              { type: ShimmerElementType.gap, width: 16, height: 125 },
                          ]}
                      />
                      <ShimmerElementsGroup
                          flexWrap
                          width="100%"
                          shimmerElements={[
                              { type: ShimmerElementType.line, width: '100%', height: 10, verticalAlign: 'bottom' },
                              { type: ShimmerElementType.line, width: '100%', height: 10 },
                              { type: ShimmerElementType.line, width: '100%', height: 10 },
                              { type: ShimmerElementType.line, width: '100%', height: 10 },
                              { type: ShimmerElementType.gap, width: '100%', height: 25 },
                          ]}
                      />
                  </div>
                  <div style={{ display: 'flex' }}>
                    <ShimmerElementsGroup
                        flexWrap
                        width="100%"
                        shimmerElements={[
                            { type: ShimmerElementType.line, width: '100%', height: 10, verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                            { type: ShimmerElementType.gap, width: '100%', height: 25 },
                        ]}
                    />
                  </div>
                  <div style={{ display: 'flex' }}>
                    <ShimmerElementsGroup
                        flexWrap
                        width="100%"
                        shimmerElements={[
                            { type: ShimmerElementType.line, width: '100%', height: 10, verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                            { type: ShimmerElementType.gap, width: '100%', height: 25 },
                        ]}
                    />
                  </div>
                </div>
              }
              styles={{
                  root: {
                      width:"100%",
                      height:"150px",
                      backgroundColor: "white"}
                  }
              }
              className="pt-4"
              isDataLoaded={currentAuth !== null}>
          </Shimmer>
        }
      </>
  );
  //#endregion
};

export default CreateClient;
